// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IWhM","buttons":"styles_buttons__2rldo"};